var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKeycodes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_961_3294)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 20,
    rx: 4,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 10.6H14.7V8.4H15.8C17.015 8.4 18 7.41495 18 6.2C18 4.98505 17.015 4 15.8 4C14.5849 4 13.6 4.98505 13.6 6.2V7.3H11.4V6.2C11.4 4.98505 10.415 4 9.2 4C7.98505 4 7 4.98505 7 6.2C7 7.41495 7.98505 8.4 9.2 8.4H10.3V10.6H9.2C7.98505 10.6 7 11.5851 7 12.8C7 14.015 7.98505 15 9.2 15C10.4151 15 11.4 14.015 11.4 12.8V11.7H13.6V12.7972C13.6 12.7984 13.5999 12.7992 13.5999 12.8C13.5999 14.015 14.5849 15 15.7999 15C17.0148 15 17.9999 14.015 17.9999 12.8C17.9999 11.5851 17.015 10.6003 15.8 10.6ZM15.8 5.1C16.4075 5.1 16.9 5.59253 16.9 6.2C16.9 6.80748 16.4075 7.3 15.8 7.3H14.7V6.2C14.7 5.59253 15.1925 5.1 15.8 5.1ZM8.1 6.2C8.1 5.59253 8.59253 5.1 9.2 5.1C9.80748 5.1 10.3 5.59253 10.3 6.2V7.3H9.2C8.59253 7.3 8.1 6.80734 8.1 6.2ZM9.2 13.9C8.59253 13.9 8.1 13.4075 8.1 12.8C8.1 12.1925 8.59253 11.7 9.2 11.7H10.3V12.8C10.3 13.4075 9.80748 13.9 9.2 13.9ZM11.4 10.6V8.4H13.6V10.6H11.4ZM15.8 13.9C15.1925 13.9 14.7 13.4075 14.7 12.8V11.7H15.7999C16.4073 11.7 16.8999 12.1925 16.8999 12.8C16.8999 13.4075 16.4075 13.9 15.8 13.9Z",
    fill: "#9B9DA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.038 4.312C25.514 4.312 25.9947 4.31667 26.48 4.326C26.9747 4.326 27.46 4.33533 27.936 4.354C28.4213 4.36333 28.8693 4.39133 29.28 4.438L29.196 5.726H25.64C25.36 5.726 25.15 5.79133 25.01 5.922C24.87 6.05267 24.8 6.258 24.8 6.538V14H23.05V6.188C23.05 5.6 23.232 5.14267 23.596 4.816C23.96 4.48 24.4407 4.312 25.038 4.312ZM23.288 8.456H28.664V9.744H23.288V8.456Z",
    fill: "#9B9DA3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_961_3294",
    x: 0,
    y: 0,
    width: 36,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_961_3294"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeycodes);
export default __webpack_public_path__ + "static/media/icon-keycodes.ecc0b10f32ea043a18ede9490e2e63dd.svg";
export { ForwardRef as ReactComponent };